"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreManager = void 0;
const firestore_1 = require("firebase/firestore");
/**
 * Firestore Service Manager
 * Handles Firebase Firestore initialization and provides database access
 */
class FirestoreManager {
    constructor() {
        this.firestore = null;
        this.initialized = false;
    }
    initialize(app) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            console.log('🚀 FirestoreManager.initialize() CALLED');
            if (this.initialized && this.firestore) {
                console.log('✅ FirestoreManager: Already initialized, returning existing instance');
                return this.firestore;
            }
            console.log('🔍 FirestoreManager: Starting platform detection...');
            console.log('window exists:', typeof window !== 'undefined');
            console.log('window.Capacitor:', typeof window !== 'undefined' ? window.Capacitor : 'N/A');
            console.log('window.Ionic:', typeof window !== 'undefined' ? window.Ionic : 'N/A');
            console.log('navigator.userAgent:', typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A');
            // Native shell only (Capacitor iOS/Android). Mobile browser is still "web" for persistence.
            let isNative = false;
            if (typeof window !== 'undefined') {
                const Cap = window.Capacitor;
                if (Cap && typeof Cap.isNativePlatform === 'function') {
                    try {
                        isNative = Cap.isNativePlatform();
                    }
                    catch (_c) {
                        isNative = false;
                    }
                }
            }
            const platform = typeof window !== 'undefined' ?
                (_b = (_a = window.Capacitor) === null || _a === void 0 ? void 0 : _a.getPlatform) === null || _b === void 0 ? void 0 : _b.call(_a) : undefined;
            console.log('📊 FirestoreManager: Platform detection RESULT:', {
                hasCapacitor: typeof window !== 'undefined' && window.Capacitor !== undefined,
                platform,
                isNative,
                userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A'
            });
            try {
                // Skip persistence on native platforms due to WKWebView/WebView IndexedDB issues
                if (isNative) {
                    console.log('📊 FirestoreManager: Native platform detected, initializing without persistence...');
                    console.log('Platform:', platform || 'unknown native');
                    this.firestore = (0, firestore_1.getFirestore)(app);
                    this.initialized = true;
                    console.log('✅ FirestoreManager: Firestore initialized for native platform (no persistence)');
                    return this.firestore;
                }
                console.log('📊 FirestoreManager: Web platform detected, initializing Firestore with offline persistence...');
                // Initialize Firestore with persistent local cache for offline support
                // This enables multi-tab support and automatic offline data caching
                this.firestore = (0, firestore_1.initializeFirestore)(app, {
                    localCache: (0, firestore_1.persistentLocalCache)({
                        tabManager: (0, firestore_1.persistentMultipleTabManager)()
                    })
                });
                this.initialized = true;
                console.log('✅ FirestoreManager: Firestore service initialized with offline persistence');
                return this.firestore;
            }
            catch (error) {
                console.error('❌ FirestoreManager: Failed to initialize Firestore:', error);
                console.log('⚠️ FirestoreManager: Falling back to default initialization without persistence...');
                // Fallback to default initialization if persistence fails
                try {
                    this.firestore = (0, firestore_1.getFirestore)(app);
                    this.initialized = true;
                    console.log('✅ FirestoreManager: Firestore initialized without persistence');
                    return this.firestore;
                }
                catch (fallbackError) {
                    console.error('❌ FirestoreManager: Fallback initialization also failed:', fallbackError);
                    throw fallbackError;
                }
            }
        });
    }
    getInstance() {
        return this.firestore;
    }
    getFirestore() {
        if (!this.firestore) {
            throw new Error('Firestore not initialized. Call initialize() first.');
        }
        return this.firestore;
    }
    isInitialized() {
        return this.initialized && this.firestore !== null;
    }
    /**
     * Reset manager for testing purposes
     */
    reset() {
        this.firestore = null;
        this.initialized = false;
    }
}
exports.FirestoreManager = FirestoreManager;
